export const MANAGE_INSTITUTE_TOTAL_ITMES_PER_PAGE = 10;
